import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/PasswordChangePage.css';

const PasswordChangePage = () => {
  const [staffID, setStaffID] = useState('');
  const [username, setUsername] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmNewPassword, setConfirmNewPassword] = useState('');
  const navigate = useNavigate();

  const handleResetPassword = () => {
    // Validate the input fields
    if (staffID && username && newPassword && newPassword === confirmNewPassword) {
      // Check if the staff ID and username are valid
      // (You'll need to implement the actual validation logic)
      if (staffID === 'ABC123' && username === 'admin') {
        // Update the user's password
        console.log('Resetting password:', { staffID, username, newPassword });
        // Redirect to the login page
        navigate('/login');
      } else {
        alert('Invalid staff ID or username. Please try again.');
      }
    } else {
      alert('Please fill in all the required fields correctly.');
    }
  };

  return (
    <div className="password-change-container">
      <h1 className="password-change-title">Forgot Password</h1>
      <div className="password-change-form">
        <input
          type="text"
          className="password-change-input"
          placeholder="Staff ID"
          value={staffID}
          onChange={(e) => setStaffID(e.target.value)}
        />
        <input
          type="text"
          className="password-change-input"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <input
          type="password"
          className="password-change-input"
          placeholder="New Password"
          value={newPassword}
          onChange={(e) => setNewPassword(e.target.value)}
        />
        <input
          type="password"
          className="password-change-input"
          placeholder="Confirm New Password"
          value={confirmNewPassword}
          onChange={(e) => setConfirmNewPassword(e.target.value)}
        />
        <button className="password-change-button" onClick={handleResetPassword}>
          Next
        </button>
        <div className="login-link">
          Remember your password? <a href="/login">Log in</a>
        </div>
      </div>
    </div>
  );
};

export default PasswordChangePage;